/* eslint-disable */
import {KTIcon, KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Link} from 'react-router-dom'
import {useState, useEffect} from 'react'
import QRScanner from '../../../../app/UI/QRScanner'
import toast, {Toaster} from 'react-hot-toast'
import 'react-toastify/dist/ReactToastify.css'
import {deleteRequest, getRequest} from '../../../../app/pages/Helpers/Requests'
import {AllChargeStationTableHeadings} from '../../../../app/pages/Helpers/TableHeadings'
import ConfirmModal from '../../../../app/modules/Confirmation/ConfirmModal'

const TableWidget98 = ({className, stations}) => {
  console.log(stations)
  const [Stations, setStations] = useState([])
  const [value, setValues] = useState<any>(null)
  const [seletedId, setSelectedId] = useState<any>()

  const DeleteHandler = async () => {
    try {
      const res = await deleteRequest(`/stations/${seletedId}`)
      console.log(res, res?.data)
      toast.success('Deleted SuccessFully')
    } catch (error) {
      console.log(error)
      // toast.error(error)
    }
  }

  return (
    <div className={`card ${className} p-3`}>
      {/* <div className='card-body py-3'> */}
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='min-w-200px'>{AllChargeStationTableHeadings.stationame}</th>
                <th className='min-w-200px'>Hub Id</th>
                <th className='min-w-200px'>Chargers</th>
                <th className='min-w-200px'>{AllChargeStationTableHeadings.location}</th>
                <th className='min-w-200px'>Type</th>
              </tr>
            </thead>
            <tbody>
              {stations.map((item: any) => {
                return (
                  <tr key={item.id}>
                    <td>
                      <a className='text-dark fw-bold d-block mb-1 fs-6'>{item.name}</a>
                    </td>
                    <td>
                      <a className='text-dark fw-bold  d-block mb-1 fs-6'>{item.hubId}</a>
                    </td>
                    <td>
                      <a className='text-dark fw-bold  d-block mb-1 fs-6'>{item?.chargers?.length}</a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>Chargers</span>
                    </td>
                   
                    
                    <td>
                      <a className='text-dark fw-bold  d-block mb-1 fs-6'>{item?.location?.city}</a>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>India</span>
                    </td>
                    <td>
                      <span
                        className={
                          item?.type == 'Public'
                            ? 'badge fs-7 fw-semibold badge-light-success'
                            : 'badge fs-7 fw-semibold badge-light-danger'
                        }
                      >
                        {item?.type}
                      </span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <ConfirmModal text='Do You Want To Delete this Station?' handleSubmit={DeleteHandler} />
      {/* </div> */}
    </div>
  )
}

export {TableWidget98}
